(function() {
  const KEY = 'spirec_collection_state';
  const TTL = 30 * 60 * 1000; // 30 min

  function isCollectionPage() {
    const path = window.location.pathname;
    return path.includes('/collections/') || path === '/' || path.includes('/search');
  }

  function getCurrentPage() {
    // Hitta högsta laddade sidan från URL eller från senast laddade pagination-knapp
    const params = new URLSearchParams(window.location.search);
    const urlPage = parseInt(params.get('page'), 10);
    if (urlPage && urlPage > 0) return urlPage;
    return 1;
  }

  function getHighestLoadedPage() {
    // pagination.js appendar produkter, men URL ändras inte. 
    // Vi räknar antal grid-items och delar med produkter-per-sida
    const grid = document.getElementById('ItemsGrid');
    if (!grid) return getCurrentPage();
    
    const items = grid.querySelectorAll('.grid-item');
    // Standard products_per_page i ditt tema är 30
    const perPage = 30;
    const startPage = getCurrentPage();
    const totalLoaded = items.length;
    const additionalPages = Math.ceil(totalLoaded / perPage) - 1;
    return startPage + additionalPages;
  }

  // Spara state när användaren klickar på en produktlänk
  document.addEventListener('click', function(e) {
    if (!isCollectionPage()) return;
    
    const link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    const state = {
      url: window.location.href,
      pathname: window.location.pathname,
      search: window.location.search,
      scroll: window.scrollY,
      highestPage: getHighestLoadedPage(),
      timestamp: Date.now()
    };
    
    sessionStorage.setItem(KEY, JSON.stringify(state));
  });

  // Vid sidladdning, kolla om vi har en saved state att återställa
  window.addEventListener('pageshow', function(e) {
    // bfcache hit - browsern har redan löst allt
    if (e.persisted) return;

    const raw = sessionStorage.getItem(KEY);
    if (!raw) return;

    let state;
    try { 
      state = JSON.parse(raw); 
    } catch (err) { 
      return; 
    }

    // Validering
    if (Date.now() - state.timestamp > TTL) {
      sessionStorage.removeItem(KEY);
      return;
    }
    if (state.pathname !== window.location.pathname) return;

    // Kolla om vi kom tillbaka till en lägre sida än vad som var laddat sist
    const currentParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(currentParams.get('page'), 10) || 1;
    
    if (state.highestPage > currentPage) {
      // Vi måste navigera till rätt sida för att slippa lazy-loada uppifrån
      const targetParams = new URLSearchParams(state.search);
      targetParams.set('page', state.highestPage);
      const targetUrl = state.pathname + '?' + targetParams.toString();
      
      // Markera att vi är mitt i en restore (för att undvika loop)
      sessionStorage.setItem(KEY + '_restoring', '1');
      window.location.replace(targetUrl);
      return;
    }

    // Om vi redan är på rätt sida (eller högre), bara scrolla
    restoreScroll(state.scroll);
  });

  function restoreScroll(targetScroll) {
    let attempts = 0;
    const maxAttempts = 50;
    
    function tryScroll() {
      attempts++;
      window.scrollTo({ top: targetScroll, behavior: 'instant' });
      
      const actualScroll = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      
      if (actualScroll < targetScroll - 100 && 
          documentHeight < targetScroll + window.innerHeight && 
          attempts < maxAttempts) {
        setTimeout(tryScroll, 100);
      } else {
        sessionStorage.removeItem(KEY);
        sessionStorage.removeItem(KEY + '_restoring');
      }
    }
    
    setTimeout(tryScroll, 100);
  }
})();